export default "__VITE_ASSET__DRRnUhuf__"